import { InitPage } from "../../../index";
import swal from "sweetalert";
import * as Toastr from "toastr";

class Index {
  private FILTER_LABELS = {
    item_alu: 'Item',
    wo_number: 'Work Order #',
    line: 'Line',
    status: 'Status',
    activity: 'Activity',
    customer_name: 'Customer Name',
    cgusa_so: 'CGUSA SO #',
    cgusa_po: 'CGUSA PO #',
    from_date: 'From Date',
    to_date: 'To Date'
  };

  constructor() {
    this.initSelect2();
    this.bindEvents();
    this.validateSelectedColumns();
  }

  htmlEscape(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  initSelect2() {
    $("#line").select2({ allowClear: true });
    $("#item").select2({ allowClear: true });
    $("#activity").select2({ allowClear: true });
    $("#status").select2({ allowClear: true });
    $("#selected_columns").select2({
      placeholder: "Pick columns to export",
      allowClear: true,
      width: '100%'
    });
  }

  bindEvents() {
    this.bindSaveTemplateButton();
    this.bindTemplateActions();
  }

  validateSelectedColumns() {
    $("#export-form").on("submit", function(e) {
      const selectedColumns = $("#selected_columns").val();
      if (selectedColumns === null || (Array.isArray(selectedColumns) && selectedColumns.length === 0)) {
        e.preventDefault();
        Toastr.error('Please select at least one column', "Error");
      }
    });
  }

  bindSaveTemplateButton() {
    $('#save-template-btn').click(() => {
      const formData = this.getFormData();
      const selectedColumns = $('#selected_columns').val() || [];

      this.renderTemplatePreview(formData, selectedColumns);
      $('#template-modal').modal('show');

      this.bindTemplateSaveConfirm(formData, selectedColumns);
    });
  }

  getFormData() {
    return {
      item_alu: $('#item').val(),
      wo_number: $('[name="wo_number"]').val(),
      line: $('#line').val(),
      status: $('#status').val(),
      activity: $('#activity').val(),
      customer_name: $('[name="customer_name"]').val(),
      cgusa_so: $('[name="cgusa_so"]').val(),
      cgusa_po: $('[name="cgusa_po"]').val(),
      from_date: $('[name="transaction_report[from_date]"]').val(),
      to_date: $('[name="transaction_report[to_date]"]').val()
    };
  }

  renderTemplatePreview(formData, selectedColumns) {
    let html = `<strong>Filters:</strong>
                <dl class="dl-horizontal">`;

    $.each(formData, (key, val) => {
      const label = this.FILTER_LABELS[key] || key;
      const display = val ? this.htmlEscape(val) : '<em>– none –</em>';
      html += `
        <dt>${label}</dt>
        <dd>${display}</dd>
      `;
    });

    html += `</dl>
             <strong>Columns:</strong>
             <ul>`;

    if (selectedColumns.length) {
      selectedColumns.forEach(col => {
        html += `<li>${this.htmlEscape(col)}</li>`;
      });
    } else {
      html += `<li><em>– none –</em></li>`;
    }

    html += `</ul>`;
    $('#template-parameters-preview').attr('style','max-height: 450px; overflow-y: scroll');
    $('#template-parameters-preview').html(html);
  }

  bindTemplateSaveConfirm(formData, selectedColumns) {
    $('#confirm-save-template').off('click').on('click', () => {
      const templateName = String($('#template_name').val() || '').trim();
      if (!templateName) {
        return Toastr.error('Please enter a template name', "Error");
      }

      if (selectedColumns.length === 0) {
        return Toastr.error('Please select at least one column', "Error");
      }

      $.ajax({
        url: $('#save-template-btn').data('save-url'),
        method: 'POST',
        dataType: 'json',
        data: {
          report_template: {
            name: templateName,
            parameters: formData,
            columns: selectedColumns
          }
        }
      })
      .done(() => {
        $('#template-modal').modal('hide');
        Toastr.success('Template saved successfully', "Success");
        setTimeout(() => {
          location.reload();
        }, 1000);
      }).fail((xhr) => {
        Toastr.error(xhr.responseJSON?.errors || "Failed to save template", "Error");
      });
    });
  }

  bindTemplateActions() {
    $(document).on('click', '.btn-delete-template', (e) => this.handleDeleteTemplate(e));
    $(document).on('click', '.btn-view-template', (e) => this.handleViewTemplate(e));
    $(document).on('click', '.btn-export-template', (e) => this.handleExportTemplate(e));
  }

  handleDeleteTemplate(e) {
    e.preventDefault();
    const templateId = $(e.currentTarget).data('template-id');
    const templateName = $(e.currentTarget).data('template-name');
    const deleteUrl = $(e.currentTarget).data('delete-url');
    
    swal({
        title: 'Are you sure?',
        text: `This operation will delete the "${templateName}" template.`,
        icon: "warning",
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: "No",
            value: null,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-red",
            closeModal: true
          }
        },
        dangerMode: true,
      }).then((willConfirm) => {
      if (willConfirm) {
        $.ajax({
          url: deleteUrl,
          method: 'DELETE',
          dataType: 'json',
          success: () => {
            Toastr.success('Template has been deleted', "Deleted!");
            $(`tr[data-template-id="${templateId}"]`).remove();
          },
          error: () => {
            Toastr.error("Could not delete template","Error");
          }
        });
      }
    });
  }

  handleViewTemplate(e) {
    e.preventDefault();
    const templateId = $(e.currentTarget).data('template-id');
    
    $.ajax({
      url: $(e.currentTarget).data('view-url'),
      method: 'GET',
      dataType: 'json',
      success: (template) => {
        this.fillFormWithTemplate(template);
        Toastr.success('Template loaded!', "Success");
      },
      error: () => {
        Toastr.error("Could not load template","Error");
      }
    });
  }

  fillFormWithTemplate(template) {
    if (template.parameters) {
      $('[name="wo_number"]').val(template.parameters.wo_number || '');
      $('[name="customer_name"]').val(template.parameters.customer_name || '');
      $('[name="cgusa_so"]').val(template.parameters.cgusa_so || '');
      $('[name="cgusa_po"]').val(template.parameters.cgusa_po || '');
      $('[name="transaction_report[from_date]"]').val(template.parameters.from_date || '');
      $('[name="transaction_report[to_date]"]').val(template.parameters.to_date || '');
      
      if (template.parameters.item_alu) {
        $('#item').val(template.parameters.item_alu).trigger('change.select2');
      }
      if (template.parameters.line) {
        $('#line').val(template.parameters.line).trigger('change.select2');
      }
      if (template.parameters.status) {
        $('#status').val(template.parameters.status).trigger('change.select2');
      }
      if (template.parameters.activity) {
        $('#activity').val(template.parameters.activity).trigger('change.select2');
      }
    }
    
    if (template.columns) {
      $('#selected_columns').val(template.columns).trigger('change.select2');
    }
  }

  handleExportTemplate(e) {
    e.preventDefault();
    const exportUrl = $(e.currentTarget).data('export-url');
    
    swal({
        title: 'Are you sure?',
        text: "It will export using the saved filters and columns.",
        icon: "warning",
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: "No",
            value: null,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-red",
            closeModal: true
          }
        },
        dangerMode: true,
    }).then((willConfirm) => {
      if (willConfirm) {
        window.location.href = exportUrl;
      }
    });
  }
}

export function LoadPage() {
  InitPage("elc reports", () => {
    InitPage("productions", () => {
      new Index();
    });
  });
}
